/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetPersonalInfoErrorResponse, GetPersonalInfoResponse } from './api.schemas';

import { api } from '../util/http';

export const getPatient = (patientId: string, signal?: AbortSignal) => {
  return api<GetPersonalInfoResponse>({ url: `/api/patient/${patientId}`, method: 'GET', signal });
};

export const getGetPatientQueryKey = (patientId?: string) => {
  return [`/api/patient/${patientId}`] as const;
};

export const getGetPatientQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatient>>,
  TError = GetPersonalInfoErrorResponse,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatient>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatient>>> = ({ signal }) =>
    getPatient(patientId, signal);

  return { queryKey, queryFn, enabled: !!patientId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientQueryResult = NonNullable<Awaited<ReturnType<typeof getPatient>>>;
export type GetPatientQueryError = GetPersonalInfoErrorResponse;

export function useGetPatient<
  TData = Awaited<ReturnType<typeof getPatient>>,
  TError = GetPersonalInfoErrorResponse,
>(
  patientId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatient>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatient>>,
          TError,
          Awaited<ReturnType<typeof getPatient>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatient<
  TData = Awaited<ReturnType<typeof getPatient>>,
  TError = GetPersonalInfoErrorResponse,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatient>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatient>>,
          TError,
          Awaited<ReturnType<typeof getPatient>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatient<
  TData = Awaited<ReturnType<typeof getPatient>>,
  TError = GetPersonalInfoErrorResponse,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatient>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatient<
  TData = Awaited<ReturnType<typeof getPatient>>,
  TError = GetPersonalInfoErrorResponse,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatient>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientQueryOptions(patientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
